<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols=0 md="2">
        </v-col>
        <v-col cols=12 md="10" class="text-left">
          <v-row>
            <v-col cols=0 sm="1" style="margin: -16px">
              <UserEditSideBar />
            </v-col>
            <v-col cols=12 md="9" class="mt-8">
              <v-row justify="start" class="mt-0 ml-0">
                <button @click="linkToProfile()" style="text-decoration: none; color: inherit;">
                  <span class="font-weight-black">
                    <v-avatar size="31" tile class="pb-1">
                      <v-img src="../../assets/chevron-left.svg"></v-img>
                    </v-avatar><span class="ml-2">プロフィール編集</span>
                  </span>
                </button>
              </v-row>
              <UserEditBase v-if="mode === 'base'"/>
              <UserEditAccount v-if="mode === 'account'"/>
              <UserEditPublicRelations v-if="mode === 'pr'"/>
              <UserEditLink v-if="mode === 'link'"/>
              <UserEditLeave v-if="mode === 'leave'"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import UserEditSideBar from '../organisms/UserEditSideBar.vue'
import UserEditBase from '../organisms/UserEditBase.vue'
import UserEditAccount from '../organisms/UserEditAccount.vue'
import UserEditPublicRelations from '../organisms/UserEditPublicRelations.vue'
import UserEditLink from '../organisms/UserEditLink.vue'
import UserEditLeave from '../organisms/UserEditLeave.vue'

export default {
  name: 'UserEditPage',
  components: {
    UserEditSideBar,
    UserEditBase,
    UserEditAccount,
    UserEditPublicRelations,
    UserEditLink,
    UserEditLeave,
  },
  data() {
    return {
      user_code: "",
      mode: "",
    }
  },
  created() {
    this.user_code = this.$store.getters['auth/isUserCode'];
    return this.mode = this.$route.params.mode;
  },
  methods: {
    linkToProfile() {
      this.$router.push({name: 'user', params: {user_code: this.user_code}})
    }
  },
  watch: {
    async $route(to, from) {
      if (to.params !== from.params) {
        return this.mode = this.$route.params.mode;
      }
    }
  },
}
</script>
<style lang="">
</style>